<app-spinner [promise]="this.getLinesPromise"></app-spinner>

<ng-container *ngIf="!this.getLinesPromise">
  <h1 mat-dialog-title>Line Picker</h1>
  <div mat-dialog-content>
    <mat-form-field appearance="fill">
      <mat-label>Factory</mat-label>
      <mat-select [(value)]="this.selectedFactoryName" required>
        <mat-option *ngFor="let factory of this.factoryNames" [value]="factory">{{factory}}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="fill">
      <mat-label>Line</mat-label>
      <mat-select [(value)]="this.selectedLine" required>
        <mat-option *ngFor="let line of this.lineOptions" [value]="line">{{line.name}}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div mat-dialog-actions>
    <button mat-button mat-dialog-close>CANCEL</button>
    <button mat-flat-button
            color="primary"
            [disabled]="!this.canSubmit"
            [mat-dialog-close]="this.getResult()">SELECT</button>
  </div>
</ng-container>